import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Invoices.frontend.types'

@Injectable({ providedIn: 'root' })
export class Invoices_invoicing_create_transactionsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { rule: $frontendTypes.Invoices.Instruction, minTaskDate: string }): Promise<{ messages?: any[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.rule)) {
      missingRequiredInParams.push('\'rule\'');
    }
    if (isNil(inParams.minTaskDate)) {
      missingRequiredInParams.push('\'minTaskDate\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/functions/invoicing_create_transactions`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

